// extracted by mini-css-extract-plugin
export default {"wrapper_header":"CreateBottle_wrapper_header__kijzh"};